import { render, staticRenderFns } from "./DetailsItem.vue?vue&type=template&id=01b0d4a4&scoped=true"
import script from "./DetailsItem.vue?vue&type=script&lang=js"
export * from "./DetailsItem.vue?vue&type=script&lang=js"
import style0 from "./DetailsItem.vue?vue&type=style&index=0&id=01b0d4a4&prod&scoped=true&lang=css"
import style1 from "./DetailsItem.vue?vue&type=style&index=1&id=01b0d4a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0d4a4",
  null
  
)

export default component.exports